import React, { useMemo } from 'react';
import { Form, FormInstance, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import ActionTypes from '@utils/deviceActions';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import rolesConstants from '@utils/rolesConstants';
import { IDevice } from '@pages/Assets/Inventory/types';

interface ImeiLockUnlockPayloadProps {
  action: ActionTypes.IMEI_LOCK | ActionTypes.IMEI_UNLOCK;
  devices: {
    msisdn: string;
  }[];
}

interface ImeiLockUnlockProps {
  devices: IDevice[];
  isUpload?: boolean;
  form: FormInstance<any>;
}

const useImeiLockUnlock = ({
  devices,
  isUpload,
  form,
}: ImeiLockUnlockProps): DeviceActionProps => {
  const { t } = useTranslation(['actions-modal', 'device-actions']);
  const imeiBlockType = Form.useWatch('imeiBlockType', form);

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('block-unlock.action'),
        name: 'imeiBlockType',
        showWhenUpload: true,
        content: (
          <Radio.Group optionType="button">
            <Radio value={ActionTypes.IMEI_LOCK}>
              {t('block-unlock.block')}
            </Radio>
            <Radio value={ActionTypes.IMEI_UNLOCK}>
              {t('block-unlock.unlock')}
            </Radio>
          </Radio.Group>
        ),
      },
    ],
    [t],
  );

  const payloadToSend = useMemo(
    (): ImeiLockUnlockPayloadProps => ({
      action: imeiBlockType ?? ActionTypes.IMEI_LOCK,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, imeiBlockType, isUpload],
  );

  return {
    title: t(`device-actions:labels.mot.${rolesConstants.IMEI_LOCK_UNLOCK}`),
    steps,
    uploadPosition: 1,
    payloadToSend,
  };
};

export default useImeiLockUnlock;
